import { IRootState } from '../../../store'
import { IGCSOptionsState } from '../store/options.types'

export const getGCSOptionsSelector = (state: IRootState): IGCSOptionsState => state.options.gcsOptions
